import type { Ceviri } from "../tip";
import type { anaSayfa as tr } from "../tr/anaSayfa";

/** English dictionary · anaSayfa. */
export const anaSayfa: Ceviri<typeof tr> = {
  ekran: {
    baslik: "Home",
    aciklama: "Your vault at a glance; the ? in each card's corner explains what the card is for.",
    okunamadi: "The vault summary could not be read",
  },

  getiri: {
    toplam: "Total return",
    sonYil: "Last 1 year",
    gunluk: "Daily",
    hesaplanamadi: (m) => `Returns could not be calculated: ${m}`,
    hesaplaniyor: "Calculating returns…",
    hesaplaniyorGun: (biten, toplam) => `Calculating returns: ${biten} / ${toplam} days`,
    etiket: (para) => `Return (${para})`,
    sebepBilinmiyor: "reason unknown",
    dipnot: (para) => `${para} · lifetime return (sales, dividends/interest included)`,
  },

  profil: {
    acikProfil: "Open profile: ",
    profilSayisi: (n) => ` · ${n} ${n === 1 ? "profile" : "profiles"}`,
    hesapYok: "No accounts in this profile yet.",
    hesaplari: "Accounts of the open profile",
    hareketSonEk: (n) => (n === 1 ? " transaction" : " transactions"),
    ayarlar: "Lock and profile settings",
  },

  hesap: {
    ozet: (hesap, hareket) =>
      `${hesap} ${hesap === 1 ? "account" : "accounts"} · ${hareket} ${hareket === 1 ? "transaction" : "transactions"}`,
    sonHareket: (gun) => ` · last transaction ${gun}`,
    hareketler: "Transactions",
    iceAktar: "Import",
    hesapAc: "Open account",
    hareketGir: "Enter transaction",
    dosyadan: "Import from file",
  },

  rapor: {
    ac: "Open Holdings",
  },

  yedek: {
    hedef: "Target",
    sonYedek: "· last backup",
    henuzYok: "none yet",
    obur: "Other devices:",
    baskaCihazYok: "no other device uses this vault",
    alindi: (n, zaman) => `${n} ${n === 1 ? "change" : "changes"} received · ${zaman}`,
    ayarlar: "Backup settings",
    kur: "Set up backup",
  },

  fiyat: {
    izlenen: (n) => `${n} ${n === 1 ? "instrument" : "instruments"} with automatically tracked prices`,
    elle: (n) => ` · ${n} manually valued ${n === 1 ? "asset" : "assets"}`,
    izleme: "Tracking",
  },

  sanal: {
    liste: "Virtual accounts",
    git: "Virtual Accounts",
  },

  tanitim: {
    satir1: "Your portfolio stays with you, private.",
    satir2: "Prices from the source.",
    satir3: "Transparent reports.",
    giris:
      "Keep a record of your shares, funds, ETFs and currency holdings; see your cost, your gains and your dividends. Your data lives only on your devices and in your own cloud.",
    kurulumMetni: "Set up a new vault, or open the vault from another device from its cloud backup.",
    kilitliMetni: "There is a vault on this device: open it with your password or your 24-word recovery phrase.",
    kurulumDugme: "Set up a vault or open from cloud",
    kilitliDugme: "Open vault",
  },

  kart: {
    ozeteDon: (baslik) => `${baslik}: back to summary`,
    neIseYarar: (baslik) => `${baslik}: what is this card for?`,
    defter: {
      baslik: "Privacy and Profiles",
      tanitim:
        "Your portfolio never leaves your device: your vault stays on this device, encrypted with your password. The server only keeps a price and exchange rate archive; it does not know who you are or what you own. You can keep several vaults (profiles) on one device: each with its own password, unseen by the others.",
    },
    baslangic: {
      baslik: "Accounts and Transactions",
      tanitim:
        "Bring your accounts at different brokers and banks together in one vault; enter your buys, sells, dividends and cash transactions. Bring in your records from another app in one go with a file.",
    },
    fiyatlar: {
      baslik: "Automatic Prices",
      tanitim:
        "BIST shares, TEFAS funds, US ETFs and exchange rates are tracked automatically. How old each price is stays visible at all times.",
    },
    raporlar: {
      baslik: "Reports / Analysis",
      tanitim:
        "FIFO cost, realised and unrealised gain, dividends and cash flow — in the currency you choose, as of the date you choose. Reports are transparent: you can see where every value comes from.",
    },
    yedek: {
      baslik: "Backup and Sync",
      tanitim:
        "Your vault is backed up, encrypted, to your own Dropbox, Google Drive or OneDrive account. Your devices using the same vault keep each other up to date through this backup.",
    },
    sanal: {
      baslik: "Virtual Accounts",
      tanitim:
        "Back-test: pick the assets, the weights, a start date and a regular purchase amount; transactions are built from the rule using past prices. Virtual accounts are not included in the vault's totals.",
    },
  },

  gorsel: {
    semaBaslik:
      "Your vault opens on your device; only its encrypted copy goes to your own cloud; only prices and exchange rates come from the Parafon server.",
    cihaz: "Your device",
    cihazAlt: "vault opens here",
    bulut: "Your own cloud",
    bulutAlt: "encrypted copy only",
    sunucu: "Parafon server",
    sunucuAlt1: "knows nothing about",
    sunucuAlt2: "you or your assets",
    sifreliYedek: "encrypted backup",
    fiyatKur: "prices and rates",
    ornekAciklama: "Sample report view: the figures are made up and do not belong to a real portfolio.",
    raporBaslik: "Report · TRY",
    ornekVeri: "Sample data",
    ornek: {
      hisse: { ad: "BIST share", deger: "48,250.00", degisim: "+12.4%" },
      fon: { ad: "TEFAS fund", deger: "31,900.00", degisim: "+6.1%" },
      abd: { ad: "US ETF", deger: "27,400.00", degisim: "−2.3%" },
    },
    toplam: "Total",
    toplamDeger: "₺107,550.00",
    nereden: "Where does this value come from?",
    neredenAyrinti: "125 units × ₺386.00 · BIST daily close",
  },
};
